const CHAR_UPPERCASE = 0;
const CHAR_LOWERCASE = 1;
const CHAR_DIGIT = 2;
const FORBIDDEN_CHARS = ['I', 'l', 'O', 'o', '1'];

const generateUpper = (): string => String.fromCharCode(65 + Math.floor(Math.random() * 26));
const generateLower = (): string => String.fromCharCode(97 + Math.floor(Math.random() * 26));
const generateNumber = (): string => String.fromCharCode(48 + Math.floor(Math.random() * 10));

const generateRandomChar = (type?: number): string => {
  let char = '';
  switch (type ?? Math.floor(Math.random() * 3)) {
    case CHAR_UPPERCASE:
      char = generateUpper();
      break;
    case CHAR_LOWERCASE:
      char = generateLower();
      break;
    case CHAR_DIGIT:
      char = generateNumber();
      break;
    default:
      break;
  }

  if (FORBIDDEN_CHARS.includes(char)) {
    char = generateRandomChar(type);
  }

  return char;
};

const shuffleString = (string: string): string => [...string]
  .map((value) => ({ value, sort: Math.random() }))
  .sort((a, b) => a.sort - b.sort)
  .map(({ value }) => value)
  .join('');

export const generateRandomString = (length: number): string => {
  if (length < 3) throw new Error('Random string length must be > 3');

  let string = generateRandomChar(CHAR_UPPERCASE) + generateRandomChar(CHAR_LOWERCASE) + generateRandomChar(CHAR_DIGIT);

  for (let index = 0; index < length - 3; index++) {
    string += generateRandomChar();
  }

  return shuffleString(string);
};
